import { defaultOrderSelections } from './types/order-selections';
export const defaultOrderDomainState = {
    order: undefined,
    selections: defaultOrderSelections,
    orderVoucherRedemptionDetailsById: {},
    orderTicketRedemptionCardRedemptionDetailsById: {},
    completedOrdersById: {},
    filmsById: {},
    ticketTypesById: {},
    itemsById: {},
    showtimesById: {},
    subscriptionsById: {},
    subscriptionBillingOptionsById: {}
};
